// Function to parse markdown-style text
export const parseMarkdown = (text) => {
  let parsedText = text;
  
  // Parse headers (### ## #)
  parsedText = parsedText.replace(/^### (.*$)/gm, '<h3 class="chat-h3">$1</h3>');
  parsedText = parsedText.replace(/^## (.*$)/gm, '<h2 class="chat-h2">$1</h2>');
  parsedText = parsedText.replace(/^# (.*$)/gm, '<h1 class="chat-h1">$1</h1>');
  
  // Parse code blocks (```code```)
  parsedText = parsedText.replace(/```([\s\S]*?)```/g, '<pre class="chat-code-block"><code>$1</code></pre>');
  
  // Parse inline code (`code`)
  parsedText = parsedText.replace(/`([^`]+)`/g, '<code class="chat-inline-code">$1</code>');
  
  // Parse bold text (**text**)
  parsedText = parsedText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  
  // Parse italic text (*text*)
  parsedText = parsedText.replace(/\*(.*?)\*/g, '<em>$1</em>');
  
  // Parse links [text](url)
  parsedText = parsedText.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="chat-link">$1</a>');
  
  // Parse line breaks
  parsedText = parsedText.replace(/\n/g, '<br>');
  
  return parsedText;
}; 